import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const TopMenuItem = ({ label, className, onClick, isActive, callbackData, href }) => {
  const classMenu = classNames('menu-in-page_item', className, {
    'is-active': isActive
  })

  const onClickHandler = (e) => {
    (typeof onClick === 'function') && onClick(callbackData)
  }

  return (
    <li className={classMenu}>
      <a className='menu-in-page_link' href={href} onClick={onClickHandler}>{label}</a>
    </li>
  )
}

TopMenuItem.defaultProps = {
  callbackData: undefined,
  isActive: false
}

TopMenuItem.propTypes = {
  label: PropTypes.string,
  href: PropTypes.string,
  className: PropTypes.string,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  callbackData: PropTypes.string
}
